import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../../component/Header";
import DiamondsFour from "../../component/SvgIcons/DiamondsFour";
import api from "../../services/axios";
import { useSwal } from "../../services/SweetAlert";
import { AnimatePresence, motion } from "framer-motion";
import utils, { phonePattern } from "../../utils/utils";
import IconError from "../../component/SvgIcons/IconError";

export default function CreateCustomers() {
  const [loading, setLoading] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [custType, setCustType] = useState([]);
  const [formData, setFormData] = useState({
    Code: "",
    Customer_Name: "",
    Serial_No: "",
    Location: "",
    City: "",
    State: "",
    Address: "",
    Contact_Person: "",
    Contact_Mobile_No: "",
    Contact_Email_Id: "",
    Customer_Type: "",
  });
  const { alert } = useSwal();    
  const user = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    utils.saveRecentSearch("Create Customer", "/create-customer");
  }, []);

  useEffect(() => {
    const fetchCustTypes = async () => {
      try {
        const res = await api.post("/Customer_Types");
        if (res.data.data && Array.isArray(res.data.data)) {
          const transformed = res.data.data.map((item) => ({
            value: item.Name,
            label: item.DisplayName,
          }));
          setCustType(transformed);
        } else {
          console.warn("Unexpected data format:", res.data.data);
        }
      } catch (error) {
        console.error("Failed to fetch customer types:", error);
      }
    };

    fetchCustTypes();
  }, []);

   // 🔁 Single source of validation rules
  const getFieldError = (name, value) => {
    switch (name) {
      case "Code":
        return !value?.trim() ? "Code is required." : "";
      case "Customer_Name":
        return !value?.trim() ? "Customer Name is required." : "";
      case "Location":
        return !value?.trim() ? "Location is required." : "";
      case "Designation":
        return !value?.trim() ? "Designation is required." : "";
      case "Address":
        return !value?.trim() ? "Address is required." : "";
      case "City":
        return !value?.trim() ? "City is required." : "";
      case "State":
        return !value?.trim() ? "State is required." : "";
      case "Customer_Type":
        return !value ? "Customer Type is required." : "";

      case "Contact_Mobile_No":
      if (!value?.trim()) return ""; // Optional field
      return phonePattern(value.trim()) ? "" : "Invalid mobile number.";

      default:
        return "";
    }
  };
   const validateField = (name, value) => {
    const error = getFieldError(name, value);
    setFormErrors((prev) => ({ ...prev, [name]: error }));
    return !error;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    validateField(name, value);
  };
  const handleCustomerTypeChange = (value) => {
    const updatedValue = formData.Customer_Type === value ? "" : value;
    setFormData((prev) => ({
      ...prev,
      Customer_Type: updatedValue,
    }));
    validateField("Customer_Type", updatedValue);
  };


    const handleSubmit = async (e) => {
    e.preventDefault();

    const requiredFields = [
      "Code",
      "Customer_Name",
      "Location",
      "Designation",
      "Address",
      "City",
      "State",
      "Customer_Type",
    ];

    let newErrors = {};
    let isValid = true;

    requiredFields.forEach((field) => {
      const error = getFieldError(field, formData[field]);
      if (error) {
        isValid = false;
        newErrors[field] = error;
      }
    });

  if (formData.Contact_Mobile_No?.trim()) {
      const mobileError = getFieldError("Contact_Mobile_No", formData.Contact_Mobile_No);
      if (mobileError) {
        isValid = false;
        newErrors.Contact_Mobile_No = mobileError;
      }
    }
    setFormErrors(newErrors);

    if (!isValid) {
      await alert("warning", "Please fill all required fields.");
      return;
    }

    const payload = {
      ...formData,
      createdby: user?.Code || "",
    };

    try {
      setLoading(true);
      await api.post("/create_customer", payload, {
        headers: { "Content-Type": "application/json" },
      });

      await alert("success", "Customer created successfully.");

      setFormData({
        Code: "",
        Customer_Name: "",
        Serial_No: "",
        Location: "",
        City: "",
        State: "",
        Address: "",
        Contact_Person: "",
        Contact_Mobile_No: "",
        Contact_Email_Id: "",
        Customer_Type: "",
        Designation: "",
      });
      setFormErrors({});
    } catch (err) {
      const message = err.response?.data?.message;
      if (message) {
        await alert("warning", message);
      } else {
        await alert("error", "Something went wrong.");
      }
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="dashboard">
      <Header title subtitle="Create Customers" searchbar />

      <div className="center-content">
        <div className="container">
          <div className="pagegap d-flex flex-column">
            <h2 className="create-titles mb-0 d-flex align-items-center">
              <DiamondsFour /> <span>Add Customer Details</span>
            </h2>

            {/* <form className="customerform myform d-flex flex-column justify-content-between" onSubmit={handleSubmit}> */}
            <AnimatePresence mode="wait">
              <motion.form
                className="customerform myform d-flex flex-column justify-content-between"
                onSubmit={handleSubmit}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -10 }}
                transition={{ duration: 0.3 }}
              >
                <div className="create-form d-flex flex-column">
                  <div className="form-row d-flex justify-content-start justify-content-lg-between  flex-wrap flex-xl-nowrap flex-column flex-lg-row">
                    <div className={`form-group ${formErrors.Customer_Name ? "fieldrequire" : ""}`}>
                      <label>
                        Customer Name{" "}
                        <span className="required-asterisk">*</span>
                      </label>
                      <input
                        type="name"
                        name="Customer_Name"
                        className="form-control"
                        placeholder="Enter Name"
                        value={formData.Customer_Name}
                        onChange={handleChange}
                      />
                     <small className="hide"><IconError/></small>   
                    </div>
                   <div className={`form-group ${formErrors.Code ? "fieldrequire" : ""}`}>
                      <label>
                        Code <span className="required-asterisk">*</span>
                      </label>
                      <input
                        type="name"
                        name="Code"
                        className="form-control"
                        placeholder="Enter Code"
                        value={formData.Code}
                        onChange={handleChange}
                      />
                     <small className="hide"><IconError/></small>   
                    </div>
                    <div className="form-group">
                      <label>Serial Number</label>
                      <input
                        type="text"
                        name="Serial_No"
                        className="form-control"
                        placeholder="Enter Serial Number"
                        value={formData.Serial_No}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="form-row d-flex justify-content-start justify-content-lg-between  flex-wrap flex-xl-nowrap flex-column flex-lg-row">
                   <div className={`form-group ${formErrors.Designation ? "fieldrequire" : ""}`}>
                      <label>
                        Designation <span className="required-asterisk">*</span>
                      </label>
                      <input
                        type="text"
                        name="Designation"
                        className="form-control"
                        placeholder="Enter Designation"
                        value={formData.Designation}
                        onChange={handleChange}
                      />
                      <small className="hide"><IconError/></small>   
                    </div>

                    <div className={`form-group ${formErrors.Location ? "fieldrequire" : ""}`}>
                      <label>
                        Location <span className="required-asterisk">*</span>
                      </label>
                      <input
                        type="text"
                        name="Location"
                        className="form-control"
                        placeholder="Enter Location"
                        value={formData.Location}
                        onChange={handleChange}
                      />   
                      <small className="hide"><IconError/></small>                   
                    </div>
                     <div className={`form-group ${formErrors.City ? "fieldrequire" : ""}`}>
                      <label>
                        City <span className="required-asterisk">*</span>
                      </label>
                      <input
                        type="text"
                        name="City"
                        className="form-control"
                        placeholder="Enter City"
                        value={formData.City}
                        onChange={handleChange}
                      />       
                      <small className="hide"><IconError/></small>                 
                    </div>
                  </div>
                  <div className="form-row d-flex justify-content-start justify-content-lg-between  flex-wrap flex-xl-nowrap flex-column flex-lg-row">
                    <div className={`form-group ${formErrors.State ? "fieldrequire" : ""}`}>
                      <label>
                        State <span className="required-asterisk">*</span>
                      </label>
                      <input
                        type="text"
                        name="State"
                        className="form-control"
                        placeholder="Enter State"
                        value={formData.State}
                        onChange={handleChange}
                      /> 
                      <small className="hide"><IconError/></small>                        
                    </div>
                   <div className={`form-group ${formErrors.Address ? "fieldrequire" : ""}`}>
                      <label>
                        Address <span className="required-asterisk">*</span>
                      </label>
                      <input
                        type="text"
                        name="Address"
                        className="form-control"
                        placeholder="Enter Address"
                        value={formData.Address}
                        onChange={handleChange}
                      />
                      <small className="hide"><IconError/></small>     
                    </div>
                     <div className="form-group">
                      <label>Contact person</label>
                      <input
                        type="text"
                        name="Contact_Person"
                        className="form-control"
                        placeholder="Enter Contact Person Name"
                        value={formData.Contact_Person}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="form-row d-flex justify-content-start justify-content-lg-between  flex-wrap flex-xl-nowrap flex-column flex-lg-row">
                   
                    <div className={`form-group ${formErrors.Contact_Mobile_No ? "fieldrequire" : ""}`}>
                    <label>
                      Mobile Number
                    </label>
                    <input
                      type="text"
                      name="Contact_Mobile_No"
                      className="form-control"
                      placeholder="Enter Mobile Number"
                      value={formData.Contact_Mobile_No}
                      onChange={handleChange}
                      inputMode="numeric"
                      onKeyDown={(e) => {
                        const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab", " "];
                        const allowedChars = /^[\d+\-\s]$/;                            
                        if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "a") {
                          return;
                        }                            
                        if (!allowedChars.test(e.key) && !allowedKeys.includes(e.key)) {
                          e.preventDefault();
                        }
                      }}   
                    />
                    <small className="hide"><IconError/></small>   
                  </div>


                    <div className="form-group">
                      <label>
                        E-Mail ID 
                      </label>
                      <input
                        type="email"
                        name="Contact_Email_Id"
                        className="form-control"
                        placeholder="Enter E-Mail ID"
                        value={formData.Contact_Email_Id}
                        onChange={handleChange}
                      />
                    </div>
                  </div>     
                      
                  <div className={`form-row d-flex justify-content-start justify-content-lg-between flex-wrap flex-xl-nowrap flex-column flex-lg-row ${formErrors.Customer_Type ? "fieldrequire" : ""}`}>
                    <div className="userrightslist">
                      <div className="userrights">
                        Select Customer Type{" "}
                        <span className="required-asterisk">*</span>
                      </div>
                      <ul className="d-flex flex-column flex-md-row justify-content-start justify-content-md-between gap-2 gap-md-2 gap-xl-0 flex-wrap flex-xl-nowrap">
                        {custType.map(({ value, label }) => (
                          <li key={value}>
                            <input
                              className="checkbox"
                              type="checkbox"
                              id={value}
                              checked={formData.Customer_Type === value}
                              onChange={() => handleCustomerTypeChange(value)}
                            />
                            <label className="checklabel" htmlFor={value}>
                              {label}
                            </label>
                          </li>
                        ))}
                      </ul>
                     <small className="hide" style={{bottom:'40px'}}><IconError/></small>
                    </div>
                  </div>
                </div>

                <div className="form-savebtns d-flex justify-content-end flex-row align-items-center">
                  <Link to="/customers-list" className="btn cancelbtn">
                    Discard
                  </Link>
                  <button
                    type="submit"
                    className="btn btngradiant"
                    disabled={loading}
                  >
                    {loading ? "Saving..." : "Save"}
                  </button>
                </div>
              </motion.form>
            </AnimatePresence>
            {/* </form> */}
          </div>
        </div>
      </div>
    </div>
  );
}
